import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDemo } from "../context/DemoContext.jsx";

export default function Header() {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const location = useLocation();
  const router = location.pathname;
  const { setDemoValue } = useDemo();

  const isActive = (path) => router === path;

  const handleShowContact = () => {
    setDemoValue("false"); // set value to share
  };

  const handleShowDemo = () => {
    setDemoValue("true"); // set value to share
  };

  return (
    <>
      <header className="section header-section">
        <div className="container">
          <div className="header-wrap">
            <div className="header-logo">
              <Link to="/">
                <img src={"/images/logo-site.png"} alt="Techwix Logo" />
              </Link>
            </div>

            {/* Desktop Menu */}
            <nav className="header-menu d-lg-block">
              <ul className="main-menu">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/service">Services</Link></li>
                <li><Link to="/team">Team</Link></li>
                <li><Link to="/testimonial">Testimonials</Link></li>
                {/* <li className={isActive("/") ? "active-menu" : ""}>
                  <Link to="/"> </Link>
                  <ul className="sub-menu">
                    <li><Link to="/">Home Main</Link></li>
                    <li><Link to="/ai-solutions">AI Solutions</Link></li>
                    <li><Link to="/blockchain-consulting">Blockchain Consulting</Link></li>
                    <li><Link to="/service">IT Solutions</Link></li>
                    <li><Link to="/about">About Company</Link></li>
                  </ul>
                </li> */}


                <li className={isActive("/about") ? "active-menu" : ""} />


                {/* <li className={isActive("/Blog") ? "active-menu" : ""}>
                  <Link href="#">Blog</Link> */}
                {/* <ul className="sub-menu">
                                        <li><Link href="/blog">Blog Grid</Link></li>
                                        <li><Link href="/blog-standard">Blog List</Link></li>
                                        <li><Link href="/blog-details">Blog Single</Link></li>
                                    </ul> */}
                {/* </li> */}

              </ul>
            </nav>

            {/* Header Meta */}
            <div className="header-meta">
              {/* <div className="header-cart dropdown">
                                <button className="cart-btn" data-bs-toggle="dropdown" onClick={()=>setShoppingCartOpen(!shoppingCart)}>
                                    <i className="fi fi-rr-shopping-cart"></i>
                                    <span className="count">0</span>
                                  </button> */}
              {/* <!-- Header Dropdown Cart Start --> */}
              {/* <div className={`dropdown-menu dropdown-cart ${shoppingCart ? 'show' : ''}`}> */}
              {/* <!-- Dropdown Cart Items Start --> */}
              {/* <div className="cart-items"> */}
              {/* <!-- Single Cart Item Start --> */}
              {/* <div className="single-cart-item">
                                      <div className="item-image">
                                        <img src="/images/shop-cart-1.jpg" alt="cart" />
                                      </div>
                                      <div className="item-content">
                                        <h4 className="title">
                                          <Link href="#">Apple Iphone X</Link>
                                        </h4>
                                        <span className="quantity">2 x $59.99</span>
                                      </div>
                                      <button className="btn-close"></button>
                                    </div> */}
              {/* <!-- Single Cart Item End --> */}
              {/* <!-- Single Cart Item Start --> */}
              {/* <div className="single-cart-item">
                                      <div className="item-image">
                                        <img src="/images/shop-cart-2.jpg" alt="cart" />
                                      </div>
                                      <div className="item-content">
                                        <h4 className="title">
                                          <Link href="#">Sony Xperia Tablet</Link>
                                        </h4>
                                        <span className="quantity">2 x $59.99</span>
                                      </div>
                                      <button className="btn-close"></button>
                                    </div> */}
              {/* <!-- Single Cart Item End --> */}
              {/* <!-- Single Cart Item Start --> */}
              {/* <div className="single-cart-item">
                                      <div className="item-image">
                                        <img src="/images/shop-cart-3.jpg" alt="cart" />
                                      </div>
                                      <div className="item-content">
                                        <h4 className="title">
                                          <Link href="#">Camera Digital</Link>
                                        </h4>
                                        <span className="quantity">2 x $59.99</span>
                                      </div>
                                      <button className="btn-close"></button>
                                    </div> */}
              {/* <!-- Single Cart Item End --> */}
              {/* </div> */}
              {/* <!-- Dropdown Cart Items End --> */}
              {/* <!-- Dropdown Cart Total Start --> */}
              {/* <div className="cart-total">
                                    <span className="label">Subtotal:</span>
                                    <span className="value">0</span>
                                  </div> */}
              {/* <!-- Dropdown Cart Total End --> */}
              {/* <!-- Dropdown Cart Button Start --> */}
              {/* <div className="cart-btns">
                                    <Link className="btn" href="#">
                                      View Cart
                                    </Link>
                                    <Link className="btn btn-2" href="#">
                                      Checkout
                                    </Link>
                                  </div> */}
              {/* <!-- Dropdown Cart Button End --> */}
              {/* </div> */}
              {/* <!-- Header Dropdown Cart End --> */}
              {/* </div> */}
              {/* <div className="header-search">
                                <Link className="search-btn" href="#">
                                  <i className="fi fi-rr-search"></i>
                                </Link>
                                <div className="search-wrap">
                                  <div className="search-inner">
                                    <i
                                      id="search-close"
                                      className="flaticon-close search-close"
                                    ></i>
                                    <div className="search-cell">
                                      <form action="#">
                                        <div className="search-field-holder">
                                          <input
                                            className="main-search-input"
                                            type="search"
                                            placeholder="Search Your Keyword..."
                                          />
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

              <div className="header-btn d-none d-xl-flex gap-2">
                <a
                  className="btn"
                  href="https://t.me/aclissglobal"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contact Us
                </a>

                {/* <Link
                  className="btn"
                  href="/contact"
                  onClick={(e) => handleShowDemo(e)}
                >
                  Get Demo
                </Link> */}
              </div>

              {/* Toggle for mobile menu */}
              <div className="header-toggle d-lg-none">
                <button onClick={() => setOffcanvasOpen(true)}>
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Offcanvas Menu */}
      <div
        className={`offcanvas offcanvas-start ${offcanvasOpen ? "show" : ""}`}
      >
        <div className="offcanvas-header">
          <div className="offcanvas-logo">
            <Link to="/">
              <img src={"/images/logo.png"} alt="Logo White" />
            </Link>
          </div>
          <button
            type="button"
            className="close-btn btn-close btn-close-white"
            aria-label="Close"
            onClick={() => setOffcanvasOpen(false)}
          >
            {/* <i className="flaticon-close"></i> Close */}
            {/* <button type="button" className="btn-close"></button> */}
          </button>
        </div>

        <div className="offcanvas-body">
          <nav className="offcanvas-menu">
            <ul className="main-menu">
              <li className="active-menu">
                <Link to="/"> </Link>
                <ul className="sub-menu">
                  {/* <li>
                    <Link to="/">Home Main</Link>
                  </li> */}
                  {/* <li><Link to="/ai-solutions">AI Solutions</Link></li>
                                    <li><Link to="/blockchain-consulting">Blockchain Consulting</Link></li>
                                    <li><Link to="/service">IT Solutions</Link></li>
                                    <li><Link to="/about">About Company</Link></li>
                                    <li><Link to="/team">Team</Link></li> */}
                </ul>
              </li>
              {/* <li>
                <Link to="/about">About Us</Link>
              </li> */}

              <li>
                <Link to="/testimonial">Testimonials</Link>
                {/*                                 
                                <ul className="sub-menu">
                                    <li><Link to="/testimonial">Testimonials</Link></li>
                                    <li><Link to="/team">Team</Link></li>
                                    <li><Link to="/contact">Contact</Link></li>
                                </ul> */}
              </li>

            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}
